import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-zinc-800 bg-[#09090b]">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between flex-wrap gap-3">
        <div className="text-[10px] uppercase tracking-widest text-zinc-600 font-medium">
          GO TRUCK YOURSELF
        </div>

        <div className="flex items-center gap-4 flex-wrap justify-center">
          <div className="text-[10px] text-zinc-700 tracking-wide">
            (c) 2026 GTY Fleet Management
          </div>
          <Link
            to="/privacy"
            className="text-[10px] uppercase tracking-widest text-zinc-600 hover:text-[#8b5cf6] transition-colors duration-200"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            className="text-[10px] uppercase tracking-widest text-zinc-600 hover:text-[#8b5cf6] transition-colors duration-200"
          >
            Terms
          </Link>
        </div>

        <a
          href="https://discord.com/invite/9PmggjVYfj"
          target="_blank"
          rel="noreferrer"
          className="text-[15px] uppercase tracking-widest text-zinc-600 hover:text-[#8b5cf6] transition-colors duration-200"
        >
          Made by Yeremii
        </a>
      </div>
    </footer>
  );
}
